import { IUseCasePrompt } from "models/IUseCasePrompt";

export interface IViewUseCasePromptProps {
  isOpen: boolean;
  onDismiss: () => void;
  useCasePrompt: IUseCasePrompt;
}

export const LABEL_VIEW = "View Use Case Prompt";
export const LABEL_CLOSE = "Close";
export const EMPTY_VALUE = "-";
